import { type ComboboxProps, type MantineStyleProps } from '@mantine/core';
import { CountryInput } from '../../inputs/CountryInput';
import { useEditorContext } from '../EditorContext';
import { setEditorFieldValue, type LooseKeys } from '../types';
import { ModalEditorItemBase } from './ModalEditorItemBase';

export interface ModalCountryItemProps<TFormType> extends Omit<ComboboxProps, 'data'> {
    fieldKey: LooseKeys<TFormType>;
    required?: boolean;
    label?: string;
    labelWidth?: number;
    w?: MantineStyleProps['w'];
}

export const ModalCountryItem = <TFormType,>({
    label,
    labelWidth,
    fieldKey,
    required,
    w,
    ...countryInputProps
}: ModalCountryItemProps<TFormType>) => {
    const { form, loading, onSave } = useEditorContext<TFormType>();

    const error = form.errors[fieldKey];

    const handleChange = (value: string | null) => {
        setEditorFieldValue(form, fieldKey, value);
    };

    return (
        <ModalEditorItemBase
            label={label}
            labelWidth={labelWidth}
            error={error}
            required={required}
            submitChanges={onSave}
        >
            <CountryInput
                value={form.getInputProps(fieldKey).defaultValue}
                key={form.key(fieldKey)}
                {...form.getInputProps(fieldKey)}
                onChange={handleChange}
                error={false}
                readOnly={loading}
                label={''}
                w={w}
                {...countryInputProps}
            />
        </ModalEditorItemBase>
    );
};
